import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import emailjs from "emailjs-com";

import styles from "./contact.module.scss";

const ContactPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "",
        values,
        process.env.REACT_APP_EMAILJS_USER_ID || ""
      )
      .then(() => {
        alert("Your enquiry has been sent successfully!");
        form.resetFields();
        setLoading(false);
      })
      .catch(() => {
        alert("Failed to send enquiry. Please try again later.");
        setLoading(false);
      });
  };

  return (
    <section className={styles.contact}>
      <div className={styles.header}>
        <h2>Contact Us</h2>
        <p>
          Let’s discuss how we can support your hiring and talent growth
          objectives.
        </p>
      </div>

      <div className={styles.container}>
        {/* Contact Info */}
        <div className={styles.info}>
          <h3>Get in Touch</h3>

          <div className={styles.item}>
            <MailOutlined />
            <div>
              <span>Email</span>
              <p>sevices@shivanthrconsultancy.com</p>
            </div>
          </div>

          {/* <div className={styles.item}>
            <PhoneOutlined />
            <div>
              <span>Phone</span>
              <p>+91 7042500421</p>
            </div>
          </div> */}

          <div className={styles.item}>
            <EnvironmentOutlined />
            <div>
              <span>Location</span>
              <p>Dwarka Mor,New Delhi, 110059, India</p>
            </div>
          </div>

          <div className={styles.note}>
            We typically respond within one business day.
          </div>
        </div>
        <Form
  layout="vertical"
  form={form}
  onFinish={onFinish}
  className={styles.formCard}
>
  <h3 className={styles.formTitle}>Send us a message</h3>

  <Form.Item
     label={<span className={styles.label}>Name</span>}
    name="name"
    rules={[{ required: true, message: "Please enter your name" }]}
  >
    <Input prefix={<UserOutlined />} placeholder="Your full name" />
  </Form.Item>

  <Form.Item
    label={<span className={styles.label}>Email</span>}
    name="email"
    rules={[{ required: true, message: "Please enter your email" }]}
  >
    <Input prefix={<MailOutlined />} placeholder="Your email address" />
  </Form.Item>

  <Form.Item
    label={<span className={styles.label}>Contact No.</span>}
    name="contact"
    rules={[{ required: true, message: "Please enter your contact number" }]}
  >
    <Input prefix={<PhoneOutlined />} placeholder="Your phone number" />
  </Form.Item>

  <Form.Item
    label={<span className={styles.label}>Address</span>}
    name="address"
    rules={[{ required: true, message: "Please enter your address" }]}
  >
    <Input prefix={<EnvironmentOutlined />} placeholder="City / Location" />
  </Form.Item>

  <Form.Item label={<span className={styles.label}>Message</span>} name="message">
    <Input.TextArea rows={4} placeholder="Write your message here…" />
  </Form.Item>

  <Button type="primary" htmlType="submit" block loading={loading}>
    Send Message
  </Button>
</Form>

        </div>


        {/* CONTACT INFO */}
        {/* <Col xs={24} md={12}>
          <BaseCard wrapperClassName={styles.infoCard}>
            <h3 className={styles.cardTitle}>Contact Information</h3>

            <div className={styles.infoItem}>
              <PhoneOutlined />
              <span>+91 7042500421</span>
            </div>

            <div className={styles.infoItem}>
              <MailOutlined />
              <span>services@shivanthrconsultancy.com</span>
            </div>

            <div className={styles.infoHighlight}>
              Send your resume at
              <strong> services@shivanthrconsultancy.com </strong>
              or WhatsApp us at
              <strong> 7042500421</strong>
            </div>
          </BaseCard>
        </Col> */}
    </section>
  );
};

export default ContactPage;
